export function runStorageMigrations() {
  try {
    // Migração legado → novo padrão de chaves (idempotente)
    // 1) authToken → accessToken em sessionStorage
    const legacyAuth = localStorage.getItem('authToken');
    if (legacyAuth) {
      sessionStorage.setItem('accessToken', legacyAuth);
      localStorage.removeItem('authToken');
    }

    // 2) Renomear chaves simples conforme Aliases
    const aliasMap: Record<string, { to: string; area: 'session' | 'local' }> = {
      currentSaveData: { to: 'cdr:export:currentSaveData', area: 'session' },
      currentSelectedItemId: { to: 'cdr:export:selectedItemId', area: 'session' },
      lastSaveRequest: { to: 'cdr:export:lastSaveRequest', area: 'session' },
      lastSaveRequestId: { to: 'cdr:export:lastSaveRequestId', area: 'session' },
      activeExportProfileId: { to: 'cdr:export:activeProfileId', area: 'local' },
      currentPedido: { to: 'cdr:order:currentPedido', area: 'session' },
      corel_organized_objects: { to: 'cdr:corel:organizedObjects', area: 'session' },
    };

    for (const [oldKey, { to, area }] of Object.entries(aliasMap)) {
      const rawSession = sessionStorage.getItem(oldKey);
      const rawLocal = localStorage.getItem(oldKey);
      const raw = rawSession ?? rawLocal;
      if (raw != null && sessionStorage.getItem(to) == null && localStorage.getItem(to) == null) {
        const target = area === 'local' ? localStorage : sessionStorage;
        try { target.setItem(to, raw); } catch {}
        // manter chave antiga por um ciclo (não remover agora)
      }
    }

    // 3) Renomear chaves dinâmicas por prefixo
    // pedidoConfig_{orcId} → cdr:order:pedidoConfig:{orcId}
    // productRules_{orcId}_{oitId} → cdr:rules:productRules:{orcId}:{oitId}
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (key.startsWith('pedidoConfig_')) {
        const orcId = key.replace('pedidoConfig_', '');
        const to = `cdr:order:pedidoConfig:${orcId}`;
        if (sessionStorage.getItem(to) == null && localStorage.getItem(to) == null) {
          try { const raw = localStorage.getItem(key); if (raw != null) localStorage.setItem(to, raw); } catch {}
        }
      }
      if (key.startsWith('productRules_')) {
        const rest = key.replace('productRules_', ''); // form: orcId_oitId
        const to = `cdr:rules:productRules:${rest.replace('_', ':')}`;
        if (localStorage.getItem(to) == null && sessionStorage.getItem(to) == null) {
          try { const raw = localStorage.getItem(key); if (raw != null) localStorage.setItem(to, raw); } catch {}
        }
      }
    }

    // 4) Remover chaves de debug herdadas
    Object.keys(localStorage)
      .filter((k) => k.startsWith('DEBUG_'))
      .forEach((k) => localStorage.removeItem(k));
  } catch {}
}


